import TestimonialWithImage from '@rsa-digital/evo-shared-components/components/TestimonialWithImage';
import mediaQuery from '@rsa-digital/evo-shared-components/helpers/mediaQuery';
import spacing from '@rsa-digital/evo-shared-components/helpers/spacing';
import styled from 'styled-components';

export const StyledTestimonialWithImage = styled(TestimonialWithImage)`
  padding-top: ${spacing(3)};
  padding-bottom: ${spacing(3)};

  ${mediaQuery.tabletLandscape`
    padding-top: ${spacing(4)};
    padding-bottom: ${spacing(4)};
  `}

  ${mediaQuery.desktop`
    padding-bottom: ${spacing(8)};
  `}
`;
